import { useOnValueChange } from '@calendly/hooks';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isSidebarOpenSelector } from './selectors';
const placeholderIsClosingCss = "pjljf0r";
const placeholderIsPhoneCss = "p1xwejim";
const placeholderCss = "p15qnhq5";
const Placeholder = forwardRef((props, ref) => {
  const {
    isClosing,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(placeholderCss, {
    [placeholderIsClosingCss]: isClosing,
    [placeholderIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const SidebarPlaceholder = () => {
  const isDesktopUp = useDeviceType('isDesktopUp');
  const isSidebarOpen = useSelector(isSidebarOpenSelector);
  const [isOpen, setIsOpen] = useState(isSidebarOpen);
  const handleAnimationEnd = useCallback(() => {
    if (!isSidebarOpen) setIsOpen(false);
  }, [isSidebarOpen]);
  useOnValueChange(isSidebarOpen, () => {
    if (isSidebarOpen) setIsOpen(true);
  });
  if (!isOpen || !isDesktopUp) return null;
  return <Placeholder isClosing={!isSidebarOpen} onAnimationEnd={handleAnimationEnd} />;
};

require("./sidebar_placeholder.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sidebar_placeholder.js");